import { WaterTankerBody } from './WaterTankerBody';
import { WATER_TANKER } from './dimensions';
import { WATER_TANKER_LAYOUT, WATER_TANKER_WHEELS } from './wheels';

const waterTanker10Preset = {
  id: 'water-tanker-10-standard',
  silhouette: 'water_tanker',
  renderModelKey: 'water_tanker',
  renderLayoutKey: 'water_tanker-10-wheel-v1',
  label: '3 axles, single steer and tandem dual drive',
  layout: WATER_TANKER_LAYOUT,
  wheels: WATER_TANKER_WHEELS,
  camera: {
    position: [11.4, 5.2, 10.2],
    target: [0, 1.75, 0],
    minDistance: 7.5,
    maxDistance: 30,
    fov: 32,
  },
  stage: { extent: WATER_TANKER.length, contactHeight: 1.5 },
  skeleton: 'axles',
  Body: WaterTankerBody,
};

export { waterTanker10Preset };
